
class CapViewStudentMap {
  constructor(config) {
    this.config = config
  }

  // eslint-disable-next-line
  checkPermission(options = {}) {
    return Boolean(this.config)
  }
}

function key() {
  return 'view_student_map'
}

function create(config) {
  return new CapViewStudentMap(config)
}

export default {
  key,
  create,
}
